import { useState, useEffect } from "react";
import { Row, Col, Skeleton } from "antd";
import OrdersTable from "./components/OrdersTable";
import OrderService from "../../utils/api/orders";
import LayoutPage from "../../layouts/Main";

export default function TogoOrdesPage() {


  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    OrderService.GetTogoServices()
      .then(resp => setOrders(resp.data.services))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <LayoutPage>
      <Row gutter={24}>
        <Col xs={24}>
          {loading ? (
            <Skeleton
              active
              paragraph={{ rows: 8 }} 
              title={false}
            />
          ) : (
            <OrdersTable
              openOrders={orders}
              loading={false}          
            />
          )}
        </Col>
      </Row>
    </LayoutPage>
  );
}
